import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Cargando...</div>;
}

const ProfileComponent = Loadable({
    loader: () => import('../../Containers/User/ProfileContainer'),
    loading: Loading,
});

const commonRoutes = [
    { path: '/profile', exact: true, name: 'Mi Cuenta', component: ProfileComponent },
];

export default commonRoutes;


// WEBPACK FOOTER //
// ./src/Routes/Modules/common.js